import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createDeviceMembershipFailed,
  createDeviceMembershipRequested,
  createDeviceMembershipSucceeded,
  deleteDeviceMembershipFailed,
  deleteDeviceMembershipRequested,
  deleteDeviceMembershipSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createDeviceMembershipRequest(deviceId, userId) {
  yield put(
    createDeviceMembershipRequested({
      deviceId,
      userId,
    }),
  );

  try {
    const { item } = yield call(request, api.createDeviceMembership, deviceId, {
      userId,
    });

    const action = createDeviceMembershipSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createDeviceMembershipFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteDeviceMembershipRequest(deviceId, userId) {
  yield put(deleteDeviceMembershipRequested(deviceId, userId));

  try {
    const { item } = yield call(request, api.deleteDeviceMembership, deviceId, userId);

    const action = deleteDeviceMembershipSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteDeviceMembershipFailed(deviceId, userId, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
